export const getMsgNum = state => state.msgObj

export const getMemberAside = state => state.memberAside

export const getUserInfo = state => {
  let userInfo = state.userInfo
  // state中没有 从localstorage中获取
  if(!userInfo.userId) {
    let localUserInfo = localStorage.getItem('userInfo')
    if(localUserInfo) {
      localUserInfo = JSON.parse(localUserInfo)
      if(localUserInfo.userId) {
        userInfo = localUserInfo
      }
    }
  }
  return userInfo
}

export const getMemberAsideAcitve = state => state.memberAsideAcitve

export const getHeadNavAcitve = state => state.headNavActive

export const getSideCollapse = state => state.sideCollapse



// WEBPACK FOOTER //
// ./src/store/getters.js